import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export const Badge = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={
      classNames(
        'inline-flex items-center rounded-md py-1 px-2 mx-2 text-xs font-medium ring-1 ring-inset text-nowrap select-none',
        className
      )
    }
    {...props}
  />
);
